import { Injectable, inject } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { TabNotificationService } from '../tab-notification/tab-notification.service';

/**
 * Route titles in the active language (staging 2026-11-05: the Home tab read "Home" in French). A route `title` that
 * is an i18n key (`sidebar.home`) is translated; a literal title (most routes still carry one) is kept as is —
 * `instant` returns its input when no key matches. Re-applied when the language changes (and when the translations
 * finish loading — the first navigation can resolve before the language file is in).
 *
 * The title goes through TabNotificationService, which owns `document.title`: it keeps the unread-count prefix,
 * "(56) Accueil · Crewdle". Setting the title here directly lost to the count, which wrote "(56) Crewdle AI".
 */
@Injectable()
export class TranslatedTitleStrategy extends TitleStrategy {
  private readonly tab = inject(TabNotificationService);
  private readonly translate = inject(TranslateService);
  private last: RouterStateSnapshot | null = null;

  constructor() {
    super();
    const reapply = () => { if (this.last) this.updateTitle(this.last); };
    this.translate.onLangChange.subscribe(reapply);
    this.translate.onTranslationChange.subscribe(reapply);
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.last = snapshot;
    const key = this.buildTitle(snapshot);
    this.tab.setPageTitle(key ? this.translate.instant(key) : null);
  }
}
